import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# **API Flows**

Create API flows to run complete simulations effortlessly.  
Use the **Add Request** button to add requests and the **Start** button to insert the starting node.

![API Flows](/flows/APIFlows.png)
`;

const FlowsDoc = () => {
    return (
        <MarkDownRenderer
            title="API Flows"
            markDownText={markdownContent}
        />
    );
};

export default FlowsDoc;
